/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Current status of the email
 * @export
 */
export const EmailStatus = {
    Draft: 'draft',
    Sending: 'sending',
    Sent: 'sent',
    Failed: 'failed'
} as const;
export type EmailStatus = typeof EmailStatus[keyof typeof EmailStatus];


export function instanceOfEmailStatus(value: any): boolean {
    for (const key in EmailStatus) {
        if (Object.prototype.hasOwnProperty.call(EmailStatus, key)) {
            if (EmailStatus[key as keyof typeof EmailStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EmailStatusFromJSON(json: any): EmailStatus {
    return EmailStatusFromJSONTyped(json, false);
}

export function EmailStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailStatus {
    return json as EmailStatus;
}

export function EmailStatusToJSON(value?: EmailStatus | null): any {
    return value as any;
}

export function EmailStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): EmailStatus {
    return value as EmailStatus;
}

